export default __webpack_public_path__ + "static/media/hamburger.ba028eea.gif";